<template>
  <div class="groupevent-box">
    <div class="groupevent-title1">Activities</div>
    <div class="groupevent-timepicker">
      Select time period:&nbsp;&nbsp;
      <el-date-picker
        v-model="userParams.start_end_time"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="datetimerange"
        range-separator="-"
        start-placeholder="Start Time"
        end-placeholder="End Time"
        size="small"
      >
      </el-date-picker>
    </div>
    <el-input
      type="textarea"
      class="activity-cont"
      v-model="userParams.activityContent"
    ></el-input>
    <div class="footer">
      <el-button @click.stop="sendGroupeEvent">Post</el-button>
    </div>
    <div class="clubcourses-box">
      <div class="myinfo-mid-content" v-loading="loading">
        <div class="list-head">
          <div class="flex_6">Even List</div>
        </div>
        <div class="list-head2">
          <div class="flex_1">Number</div>
          <div class="flex_3">Content</div>
          <div class="flex_1">Start Time</div>
          <div class="flex_1">End Time</div>
          <div class="flex_1">Create Time</div>
          <div class="flex_1">Status</div>
          <div class="flex_1">Read Count</div>
        </div>

        <div
          class="list-content"
          v-for="(item, index) in groupEventList"
          :key="index"
        >
          <div class="flex_1">
            {{ item.c_id }}
          </div>
          <div class="flex_3">
            <div class="info-detail">
              <el-tooltip
                effect="light"
                :content="item.content ? item.content : ''"
                placement="bottom-start"
              >
                <div class="detail-content">
                  {{ item.content }}
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="flex_1">
            {{ item.starttime | formatTime }}
          </div>
          <div class="flex_1">
            {{ item.endtime | formatTime }}
          </div>
          <div class="flex_1">
            {{ item.create_time | formatTime }}
          </div>
          <div class="flex_1">
            <el-tag
              v-if="item.status === 1"
              type="warning"
              effect="plain"
              size="mini"
            >
              In progress
            </el-tag>
            <el-tag
              v-if="item.status === 0"
              type="info"
              effect="plain"
              size="mini"
            >
              Finished
            </el-tag>
          </div>
          <div class="flex_1">
            <div class="rcount" @click="goToEventDetail(item.c_id)">
              {{ item.r_count }}
            </div>
            <div class="detail" @click="goToEventDetail(item.c_id)">view</div>
          </div>
        </div>
        <div v-if="groupEventList.length < 5">
          <div
            class="list-content"
            v-for="index in 5 - groupEventList.length"
            :key="index"
          >
            <div class="flex_1"></div>
            <div class="flex_3"></div>
            <div class="flex_1"></div>
            <div class="flex_1"></div>
            <div class="flex_1"></div>
            <div class="flex_1"></div>
            <div class="flex_1"></div>
          </div>
        </div>
      </div>
      <KtPag
        :pageCount="pageParams.count"
        :limit="pageParams.limit"
        :currentPage="pageParams.page"
        @onChange="handleChange"
      ></KtPag>
    </div>
  </div>
</template>

<script>
import KtPag from "@/views/Comm/KtPag";
import moment from "moment";
export default {
  components: {
    KtPag,
  },
  data() {
    return {
      userParams: { start_end_time: [], activityContent: "" },
      pageParams: { page: 1, limit: 5, count: 0 },
      groupEventList: [],
      loading: false,
    };
  },
  filters: {
    formatTime(val) {
      if (val && moment(val).isValid()) return moment(val).format("YYYY.MM.DD");
      else return "";
    },
  },
  mounted() {
    this.getGroupEventList(1);
  },
  methods: {
    async sendGroupeEvent() {
      let params = { ...this.userParams };
      if (!params.activityContent) {
        this.$message({
          type: "warning",
          message: "Please fill in the content of the activities",
        });
        return;
      }
      if (
        this.userParams.start_end_time &&
        this.userParams.start_end_time.length > 0
      ) {
        params["starttime"] = moment(this.userParams.start_end_time[0]).format(
          "YYYY-MM-DD"
        );
        params["endtime"] = moment(this.userParams.start_end_time[1]).format(
          "YYYY-MM-DD"
        );
        delete params.start_end_time;
      } else {
        this.$message({
          type: "warning",
          message:
            "Please select a time period for the eventFailed to send activities",
        });
        return;
      }
      const { status, message } = await this.$api.courseApi.sendGroupeEvent(
        params
      );
      if (status === "0") {
        this.$message({
          type: "success",
          message: "Successfully post",
        });
        this.userParams = { start_end_time: [], activityContent: "" };
        this.getGroupEventList(1);
      } else {
        this.$message({
          type: "error",
          message: "Failed to send event",
        });
      }
    },
    goToEventDetail(c_id) {
      this.$router.push("/groupInfo/eventusers?c_id=" + c_id);
    },
    async getGroupEventList(type) {
      this.loading = true;
      let params = {};
      params["page"] = this.pageParams.page;
      params["limit"] - this.pageParams.limit;
      if (type === 1) {
        params["page"] = 1;
      }
      const { status, message, data } =
        await this.$api.courseApi.getGroupEventList(params);
      if (status === "0") {
        this.groupEventList = data.rows;
        this.pageParams.count = data.count;
      } else {
        this.$message({
          type: "error",
          message: message,
        });
      }
      this.loading = false;
    },
    //跳转页面时触发
    handleChange({ page, limit }) {
      this.pageParams = Object.assign({}, this.pageParams, { page, limit });
      this.getGroupEventList(2);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.groupevent-box {
  padding: 24px;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
  .kt-page {
    text-align: right;
  }
  .groupevent-title1 {
    height: vh(25);
    font-size: vh(18);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #181d2c;
    line-height: vh(25);
    margin-bottom: vh(10);
  }
  .groupevent-timepicker {
    margin-bottom: vh(15);
  }
  /deep/ .el-textarea__inner {
    height: vh(245);
    padding: 14px 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #181d2c;
    line-height: 20px;
  }
  .footer {
    text-align: right;
    padding-top: vh(24);
    .el-button {
      width: vw(100);
      height: vw(40);
      background: #f48c06;
      border-radius: 4px;
      color: #ffffff;
      font-weight: 500;
      font-size: 14px;
      border: none;
      outline: none;
      &:hover {
        opacity: 0.54;
      }
    }
  }
  .clubcourses-box {
    padding: 24px;
    margin-top: 15px;
    box-sizing: border-box;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
    .myinfo-mid-content {
      // margin-top: vw(32);
      // box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
      // border-radius: 24px;
      // background: #ffffff;
      .flex_1 {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        .rcount {
          cursor: pointer;
          &:hover {
            color: #f48c06;
            text-decoration: underline;
            opacity: 0.54;
          }
        }
        .detail {
          cursor: pointer;
          margin-left: 10px;
          color: #f48c06;
          text-decoration: underline;
          opacity: 0.54;
        }
      }
      .flex_3 {
        flex: 3;
      }
      .list-head {
        height: vh(40);
        line-height: vh(40);
        font-size: 18px;
        font-weight: 500;
        color: #181d2c;
        box-sizing: border-box;
        padding-left: vw(10);
        display: flex;
      }
      .list-head2 {
        height: vh(40);
        line-height: vh(40);
        font-size: 16px;
        font-weight: 500;
        color: #181d2c;
        box-sizing: border-box;
        padding-left: vw(10);
        display: flex;
      }
      .list-content {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        height: vh(120);
        padding: vh(24) 0;
        box-sizing: border-box;
        border-top: 1px solid #dbd9d6;
        font-size: 14px;
        .info-img {
          width: 20%;
          height: 100%;
          border-radius: 8px;
          display: inline-block;
        }
        .info-detail {
          width: 100%;
          display: inline-block;
          padding-left: vw(16);
          box-sizing: border-box;
          .detail-content {
            height: vh(72);
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #181d2c;
            line-height: vh(24);
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 3;
            line-clamp: 3;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }
}
</style>
